var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterWell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3,
    width: 12,
    height: 20,
    rx: 1,
    stroke: "#637381"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 10,
    width: 10,
    height: 12,
    rx: 1,
    fill: "#2486FD",
    fillOpacity: 0.2,
    stroke: "#1070CA",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5L14.5981 8H9.40192L12 5Z",
    fill: "#CBDFF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterWell);
export default __webpack_public_path__ + "static/media/water_well.3438de6f185ab0718715cf0e68d70df2.svg";
export { ForwardRef as ReactComponent };